import { OrderItems } from '@widgets/desktop/profile-history/ui/profile-history.types';

export const getGroupedOrderItems = (items: OrderItems[]) => {
  const result: {
    id: number;
    price: number;
    count: number;
    selected: boolean;
    prices: number[];
  }[] = [];

  const map = new Map<number, (typeof result)[0]>();

  for (const item of items) {
    const pid = item.productId;
    const price = parseFloat(item.price);

    if (!map.has(pid)) {
      map.set(pid, {
        id: pid,
        price,
        count: 1,
        selected: false,
        prices: [price],
      });
    } else {
      const entry = map.get(pid)!;
      entry.count += 1;
      entry.prices.push(price);
    }
  }
  return Array.from(map.values());
};
